export const headers = [
  { field: "id", headerName: "ID", width: 70, hide: true }, // `hide` en vez de `hidden`
  { field: "desc_descripcion", headerName: "Descripción", width: 230 },
  { field: "desc_porcentaje", headerName: "Porc.(%)", width: 80, type: "number" },
  { field: "monto_minimo", headerName: "Monto Mínimo", width: 130, type: "number" },
  { field: "monto_maximo", headerName: "Monto Máximo", width: 130, type: "number" },
  {
    field: "desc_fecha_inicio",
    headerName: "Fecha Inicio",
    width: 130,
    type: "dateTime",
    valueGetter: (params) => {
      const val = params.row.desc_fecha_inicio;
      if (!val) return "";
      const date = new Date(val);
      if (isNaN(date)) return "";
      return date.toLocaleString("es-ES", {
        day: "2-digit",
        month: "2-digit",
        year: "2-digit",
        hour: "2-digit",
        minute: "2-digit",
      });
    },
  },
  {
    field: "desc_fecha_fin",
    headerName: "Fecha Fin",
    width: 130,
    type: "dateTime",
    valueGetter: (params) => {
      const val = params.row.desc_fecha_fin;
      if (!val) return "";
      const date = new Date(val);
      if (isNaN(date)) return "";
      return date.toLocaleString("es-ES", {
        day: "2-digit",
        month: "2-digit",
        year: "2-digit",
        hour: "2-digit",
        minute: "2-digit",
      });
    },
  },

  {
    field: "desc_activo",
    headerName: "Activo",
    width: 100,
    type: "boolean",
    renderCell: (params) => (params.value === true ? "Activo" : "Inactivo"),
  }

];
